module.exports = __webpack_public_path__ + "static/media/opensans-bold.1025a6e0.ttf";